(() => {
  const WHATSAPP_NUMBER = '8618221800251';
  const FLOAT_SESSION_KEY = 'lanjing_whatsapp_float_animated';
  const floatButton = document.querySelector('[data-lj-whatsapp-float]');

  const cleanUrl = () => `${window.location.origin}${window.location.pathname}`;

  const buildMessage = (source, link) => {
    const pageTitle = link?.dataset?.ljPageTitle || document.title.replace(/\s*[–|-]\s*Lanjing MFG.*$/i, '').trim();
    const pageUrl = cleanUrl();

    if (source === 'home_hero') {
      return [
        'Hi Lanjing MFG,',
        '',
        'I am interested in your wholesale catalog.',
        'Country:',
        'Business type:',
        'Estimated quantity:',
        'Products interested in:',
      ].join('\n');
    }

    if (source === 'contact_page') {
      return [
        'Hi Lanjing MFG,',
        '',
        'I would like to speak with your wholesale team.',
        'Country:',
        'Business type:',
        'Estimated quantity:',
        'Question:',
      ].join('\n');
    }

    if (source === 'footer') {
      return [
        'Hi Lanjing MFG,',
        '',
        'I found your contact details on the website and would like wholesale information.',
        'Country:',
        'Estimated quantity:',
        `Page: ${pageUrl}`,
      ].join('\n');
    }

    return [
      'Hi Lanjing MFG,',
      '',
      'I am browsing your wholesale website and would like more information.',
      `Page: ${pageTitle}`,
      `Link: ${pageUrl}`,
      '',
      'Country:',
      'Business type:',
      'Estimated quantity:',
      'Products interested in:',
    ].join('\n');
  };

  const resolveSource = (link) => {
    if (link.dataset.ljWhatsappSource) return link.dataset.ljWhatsappSource;
    if (link.matches('[data-lj-product-whatsapp]')) return 'product_detail';
    if (link.closest('.lanjing-footer')) return 'footer';
    if (link.closest('.lanjing-hero')) return 'home_hero';
    if (link.closest('.lj-contact')) return 'contact_page';
    return 'other_whatsapp';
  };

  const publishClick = (link, source) => {
    const payload = {
      button_location: source,
      page_type: document.querySelector('main[data-template]')?.dataset.template || document.body.className,
      page_title: document.title,
      page_url: window.location.href,
      destination: 'whatsapp',
      product_title: link.closest('[data-lj-product-inquiry]')?.dataset.productTitle || undefined,
    };

    try {
      window.Shopify?.analytics?.publish?.('lanjing:whatsapp_click', payload);
    } catch (error) {
      console.debug('Lanjing analytics publish unavailable', error);
    }

    try {
      window.gtag?.('event', 'whatsapp_click', payload);
    } catch (error) {
      console.debug('GA4 click event unavailable', error);
    }

    try {
      window.dataLayer?.push?.({ event: 'whatsapp_click', ...payload });
    } catch (error) {
      console.debug('dataLayer unavailable', error);
    }

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Contact', payload, { eventID: `wa_${Date.now()}_${Math.random().toString(36).slice(2, 9)}` });
      }
    } catch (error) {
      console.debug('Meta Contact event unavailable', error);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"], [data-lj-product-whatsapp]');
      if (!link) return;

      const source = resolveSource(link);
      if (!link.matches('[data-lj-product-whatsapp]')) {
        link.href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(buildMessage(source, link))}`;
      }
      publishClick(link, source);
    },
    true,
  );

  if (!floatButton) return;

  const displayMode = floatButton.dataset.ljDisplayMode || 'delayed';
  let eligible = false;
  let expandedTimer = null;

  const privacyBannerOpen = () => Boolean(
    document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog, [data-shopify-privacy-banner]')
  );

  const pageOverlayOpen = () => Boolean(
    document.body.classList.contains('overflow-hidden') ||
    [...document.body.classList].some((name) => name.startsWith('overflow-hidden-')) ||
    document.querySelector('cart-drawer.active, .lj-header__mobile[open], dialog[open], .menu-opening') ||
    privacyBannerOpen()
  );

  const updateVisibility = () => {
    const shouldShow = eligible && !pageOverlayOpen();
    floatButton.classList.toggle('is-visible', shouldShow);
    floatButton.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    floatButton.tabIndex = shouldShow ? 0 : -1;
  };

  const brieflyExpandOnMobile = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    try {
      if (sessionStorage.getItem(FLOAT_SESSION_KEY)) return;
      sessionStorage.setItem(FLOAT_SESSION_KEY, '1');
    } catch (_) {}

    window.setTimeout(() => {
      if (!floatButton.classList.contains('is-visible')) return;
      floatButton.classList.add('is-expanded', 'is-introducing');
      window.clearTimeout(expandedTimer);
      expandedTimer = window.setTimeout(() => {
        floatButton.classList.remove('is-expanded', 'is-introducing');
      }, 3600);
    }, 650);
  };

  const makeEligible = () => {
    if (eligible) return;
    eligible = true;
    updateVisibility();
    brieflyExpandOnMobile();
  };

  if (displayMode === 'home_after_hero') {
    const hero = document.querySelector('[data-lj-home-hero], .lanjing-hero');
    if (hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.12) makeEligible();
        },
        { threshold: [0, 0.12] },
      );
      observer.observe(hero);
    } else {
      window.setTimeout(makeEligible, 5000);
    }
  } else {
    window.setTimeout(makeEligible, 4200);
    const onScroll = () => {
      const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY / scrollable > 0.14) {
        makeEligible();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const bodyObserver = new MutationObserver(updateVisibility);
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const cartObserver = new MutationObserver(updateVisibility);
    cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('toggle', updateVisibility, true);
  window.addEventListener('resize', updateVisibility, { passive: true });
})();
